import React from "react";

interface PageHeaderProps {
  title: string;
  description?: React.ReactNode;
  badge?: React.ReactNode;
}

/**
 * A header component for page titles with optional description and badge.
 */
export function PageHeader({ title, description, badge }: PageHeaderProps) {
  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-foreground">{title}</h1>
        {badge && <div>{badge}</div>}
      </div>
      {description && (
        <p className="text-muted-foreground mb-8">{description}</p>
      )}
    </>
  );
}

